/*
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-10-17 10:46:30
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-10-17 15:15:52
 * @FilePath: \overseas-wpcweb\src\i18n\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enElement from 'element-ui/lib/locale/lang/en';
import zhElement from 'element-ui/lib/locale/lang/zh-CN';
import localZh from './zh';
import localEn from './en';
import ElementLocale from 'element-ui/lib/locale';

Vue.use(VueI18n);
// 现在包含中英两种语言 如若需要其他语言请在 http://element-cn.eleme.io/#/zh-CN/component/i18n 中寻找
const localeMessages = {
  en: {
    ...localEn,
    ...enElement
  },
  zh: {
    ...localZh,
    ...zhElement
  }
};

if (!localStorage.getItem('language')) {
  localStorage.setItem('language', 'en');
}

const i18n = new VueI18n({
  locale: localStorage.getItem('language'),
  messages: localeMessages,
});

ElementLocale.i18n((key, value) => i18n.t(key, value));

export default i18n;
